import Log, {Errors} from "@khan/logging";

import {isKhanAcademyUrl} from "./is-khan-academy-url.ts";

/**
 * Either continueUrl or fallbackUrl (when the continueUrl is not 'safe').
 *
 * We need this to avoid serving as an open redirect.
 *
 * @see lib/url_util.py#validated_continue_url
 *
 * @param {string} continueUrl The URL to be redirected to.
 * @param {string} fallbackUrl The optional fallback URL set in case the
 * continueURL is invalid.
 * @returns {string} The validated continue URL.
 */
export const validateContinueUrl = (
    continueUrl: string,
    fallbackUrl?: string,
): string => {
    // If this function is changed, double-check that an equivalent change
    // isn't needed on ValidatedContinueURL in Go
    // (services/users/auth/login_state.go)
    if (!isKhanAcademyUrl(continueUrl)) {
        Log.error("Invalid continue URI. Ignoring", Errors.Internal, {
            sentryData: {
                contexts: {
                    extras: {
                        continueUrl,
                    },
                },
            },
        });
        return fallbackUrl || "";
    }

    return continueUrl;
};
